function updateBrokerFieldValueBase(formData, fieldName, fieldType, id, value) {
  if (fieldName && fieldType) {
    formData[`${id}-${fieldType}-${fieldName}`] = value;
  } else if (fieldType) {
    formData[`${id}-${fieldType}`] = value;
  } else {
    formData[`${id}`] = value;
  }

  return formData;
}

export function updateBrokerFieldValue(state = {}, action) {
  const { formData } = state || {};
  const { fieldName, fieldType, id, value } = action || {};
  const formDataFormatted = { ...formData };

  return updateBrokerFieldValueBase(
    formDataFormatted,
    fieldName,
    fieldType,
    id,
    value
  );
}

export function updateBrokerEditField(state, action) {
  const { dataFormatted, formData } = state || {};
  const { id, enableEdit = false } = action || {};
  const newDataFormatted = [...dataFormatted];
  const targetIndex = newDataFormatted.findIndex((item) => item.id === id);
  let formDataFormatted = { ...formData };

  if (targetIndex < 0) {
    return newDataFormatted;
  }

  const { key, value } = newDataFormatted[targetIndex];

  if (enableEdit) {
    newDataFormatted[targetIndex].isValue = true;

    formDataFormatted = updateBrokerFieldValueBase(
      formDataFormatted,
      undefined,
      'key',
      id,
      key
    );

    formDataFormatted = updateBrokerFieldValueBase(
      formDataFormatted,
      undefined,
      'value',
      id,
      value
    );
  } else {
    delete newDataFormatted[targetIndex].isValue;

    formDataFormatted = updateBrokerFieldValueBase(
      formDataFormatted,
      undefined,
      'key',
      id,
      undefined
    );

    formDataFormatted = updateBrokerFieldValueBase(
      formDataFormatted,
      undefined,
      'value',
      id,
      undefined
    );
  }

  return {
    ...state,
    dataFormatted: newDataFormatted,
    formData: formDataFormatted,
  };
}
